export const aceAssignmentKeys = {
  root: () =>
    ({
      service: 'ace',
      scope: 'assignments-v3',
    } as const),

  agent: (agentId: string) =>
    ({
      ...aceAssignmentKeys.root(),
      entity: 'agent',
      id: agentId,
    } as const),

  application: (applicationId: string) =>
    ({
      ...aceAssignmentKeys.root(),
      entity: 'application',
      id: applicationId,
    } as const),

  agentAssignments: (agentId: string) =>
    ({
      ...aceAssignmentKeys.root(),
      entity: 'agent-assignments',
      id: agentId,
    } as const),
};
